import { Component } from "@mna/react";
import Form from "@mna/react-ui/Form";
import schema from "@mna/schema";
import { Trans } from "react-i18next";
import i18next from "i18next";
import terms from "assets/img/terms.png";
import { googleMapsApiKey } from "client.config";
import LoadingScreen from "features/LoadingScreen";
import PlacesAutocomplete from "react-places-autocomplete";
import Switch from "react-switch";
import UserCreatedSuccessfully from "../../features/UserCreatedSuccessfully";
import { commonConstant } from "../../server/triage/constants";
import { DateValidation, getDate, check } from "../../features/utils";
import PhoneInput from "react-phone-input-2";
import "../../styles/style.scss"

var doBValue;

const initialState = {
	firstErrorMsg: "",
	secondErrorMsg: "",
	dateErrorMsg: "",
	addressErrorMsg: "",
	phoneErrorMsg: "",
	dateErrorMsgFrom: "",
	dateErrorMsgTo: "",
	insuranceErrorMsg: "",
	policyErrorMsg: "",
	effectToMsg: "",
	effectFromMsg: "",
};

var policyFromMinDate = getDate(new Date(), -1);
var policyToMinDate = "";
var policyToMaxDate = "";
class Profile extends Component {
	state = initialState;
	constructor(props) {
		super(props);
		this.state = {
			mapLoaded: false,
			geoAddress: "",
			showError: false,
			showErrorPhone: false,
			checked: true,
			shouldUiBeChanged: false,
		};
		this.handleChange = this.handleChange.bind(this);
	}
	initMap = () => {
		this.setState({
			mapLoaded: true,
		});
	};
	componentDidMount() {
		window.initMap = this.initMap;
		const gmapScriptEl = document.createElement(`script`);
		gmapScriptEl.src = `https://maps.googleapis.com/maps/api/js?key=${googleMapsApiKey}&libraries=places&callback=initMap`;
		document
			.querySelector(`body`)
			.insertAdjacentElement(`beforeend`, gmapScriptEl);
	}
	handleGeoChange = (address) => {
		this.setState({ geoAddress: address });
	};

	handleChange(checked) {
		this.setState({ checked });
	}

	render() {
		const {
			state,
			history,
			actions,
			setState,
			state: { triageRequest },
		} = this.props;

		const formSchema = schema(({ string }) => ({
			first: string,
			last: string,
			phone: string,
			house: string,
			date: string,
			effectTo: string,
			effectFrom: string,
			Insurance: string,
			policy: string,
		}));
		var dynamicClass;
		if (this.state.showError) {
			dynamicClass =
				"mt-10 mb-10 form-control location-search-input is-error noborder-withbackground text-field w-select";
		} else {
			dynamicClass =
				"mt-10 mb-10 form-control location-search-input noborder-withbackground text-field w-select";
		}

		var homecity = i18next.t("userregistration.homecity");

		return (
			<div className="page-section-2">
				<Form
					className="content content-unset"
					fields={triageRequest.serviceRequest}
					onValidate={(data) => {
						const errors = {};
						let firstError = "";
						let secondError = "";
						let dateError = "";
						let addressError = "";
						let insuranceError = "";
						let policyError = "";
						let errorMsg = "";
						let dateErrorFrom = "";
						let dateErrorTo = "";
						const required = "REQUIRED";
						const date = "Date";
						const fromDate = "fromDate";
						const toDate = "toDate";

						var scheme = formSchema(data);

						if (scheme !== null && scheme.first === required)
							errors.first = required;

						if (scheme !== null && scheme.last === required)
							errors.last = required;

						if (scheme !== null && scheme.date === required)
							errors.date = required;
						if (scheme !== null && scheme.effectTo === required)
							errors.effectTo = required;
						if (scheme !== null && scheme.effectFrom === required)
							errors.effectFrom = required;
						if (scheme !== null && scheme.Insurance === required)
							errors.Insurance = required;
						if (scheme !== null && scheme.policy === required)
							errors.policy = required;

						if (data.Insurance === "") {
							insuranceError = (
								<Trans i18nKey="userregistration.validation.insurance_msg">
									Please enter the insurance details
								</Trans>
							);
							errors.Insurance = required;
						}
						this.setState({ insuranceErrorMsg: insuranceError });

						if (data.policy === "") {
							policyError = (
								<Trans i18nKey="userregistration.validation.policy_msg">
									Please enter the valid policy number
								</Trans>
							);
							errors.policy = required;
						}
						this.setState({ policyErrorMsg: policyError });

						if (this.state.geoAddress == "") {
							addressError = (
								<Trans i18nKey="userregistration.validation.address">
									Address cannot be empty
								</Trans>
							);
							this.setState({
								showError: true,
							});
							errors.house = required;
						} else if (this.state.geoAddress.trim().length <= 2) {
							addressError = (
								<Trans i18nKey="userregistration.validation.address_msg1">
									Please enter the valid address
								</Trans>
							);
							this.setState({
								showError: true,
							});
							errors.house = required;
						} else {
							this.setState({
								showError: false,
							});
						}
						this.setState({ addressErrorMsg: addressError });

						errorMsg = (
							<Trans i18nKey="userregistration.validation.date">
								Date field cannot be empty
							</Trans>
						);
						this.setState({
							dateErrorMsg: DateValidation(
								state,
								state.enteredbirthday,
								true,
								errorMsg
							),
						});
						errorMsg = (
							<Trans i18nKey="userregistration.validation.from_date">
								{" "}
								From date cannot be empty
							</Trans>
						);

						this.setState({
							dateErrorMsgFrom: DateValidation(
								state,
								state.enteredStartdate,

								true,
								errorMsg
							),
						});
						errorMsg = (
							<Trans i18nKey="userregistration.validation.to_date">
								{" "}
								To date cannot be empty
							</Trans>
						);

						this.setState({
							dateErrorMsgTo: DateValidation(
								state,
								state.enteredEnddate,
								true,
								errorMsg
							),
						});

						if (Object.keys(errors).length) return errors;
					}}
					onSubmit={async (data) => {
						state.triageRequest.profile = data;
						console.log("dataprofile ", data);

						if (!this.state.checked) {
							history.push(`/create-primary`);
						} else {
							var triageRequests = state.triageRequest;
							if (
								state.triageRequest.profile &&
								state.triageRequest.profile.date
							) {
								doBValue = actions.generalDate({
									dateVal: state.triageRequest.profile.date.trim(),
								});
							}
							setState({
								isLoading: true,
							});

							var callOnBoardResponse = await actions.CallOnBoard(
								state,
								setState,
								actions,
								triageRequests,
								doBValue
							);

							if (
								callOnBoardResponse &&
								callOnBoardResponse.success === commonConstant.true
							) {
								this.setState({
									shouldUiBeChanged: true,
								});
							} else {
								this.setState({
									shouldUiBeChanged: false,
								});
							}
							setState({
								isLoading: false,
							});
						}
					}}
				>
					{({ fields, invalidFields }) => (
						<div className="container-2 w-container">
							<LoadingScreen isLoading={state.isLoading}>
								{!this.state.shouldUiBeChanged ? (
									<div className="w-row">
										<div className="column w-col w-col-1 w-col-tiny-tiny-stack"></div>
										<div className="column-2 w-col w-col-5 w-col-tiny-tiny-stack">
											<div className="column-2 w-col w-col-tiny-tiny-stack">
												<h2>
													<Trans i18nKey="userregistration.step-3heading">
														Let's setup your profile
													</Trans>
												</h2>
												<div className="w-col w-col-tiny-tiny-stack">
													<div className="column-2 w-col w-col-6 w-col-tiny-tiny-stack">
														<input
															id="firstname-input"
															type="text"
															defaultValue={
																state.triageRequest.createUser &&
																state.triageRequest.createUser.first
																	? state.triageRequest.createUser.first.trim()
																	: fields.first
															}
															name="first"
															placeholder={i18next.t(
																"userregistration.Firstname"
															)}
															readOnly
															className={
																invalidFields.first
																	? "is-error"
																	: "text-field w-input"
															}
														/>
														<div className="errormessagetext1">
															{this.state.firstErrorMsg}
														</div>
													</div>
													<div className="column-2 w-col w-col-6 w-col-tiny-tiny-stack">
														<input
															id="lastname-input"
															type="text"
															defaultValue={
																state.triageRequest.createUser &&
																state.triageRequest.createUser.last
																	? state.triageRequest.createUser.last.trim()
																	: ""
															}
															placeholder={i18next.t(
																"userregistration.Lastname"
															)}
															name="last"
															readOnly
															className={
																invalidFields.last
																	? "is-error"
																	: "text-field w-input"
															}
														/>
														<div className="errormessagetext">
															{this.state.secondErrorMsg}
														</div>
													</div>
												</div>
												<div className="w-col w-col-tiny-tiny-stack">
													<div className="column-2 w-col w-col-6 w-col-tiny-tiny-stack">
														<input
															id="Calender"
															type="text"
															placeholder={i18next.t(
																"userregistration.user-DOB"
															)}
															defaultValue={
																state.triageRequest.profile &&
																state.triageRequest.profile.date
																	? state.triageRequest.profile.date.trim()
																	: fields.date
															}
															name="date"
															className={
																invalidFields.date
																	? "is-error"
																	: "text-field w-input"
															}
															onChange={(e) => {
																setState({
																	enteredbirthday: e.currentTarget.value,
																});
															}}
															onFocus={(e) => {
																e.currentTarget.type = "date";
															}}
															onBlur={(e) => {
																e.currentTarget.placeholder =
																	"DOB (dd/mm/yyyy)";
															}}
														/>
														<div className="errormessage-date">
															{this.state.dateErrorMsg}
														</div>
													</div>
													<div className="w-col w-col-6 w-col-tiny-tiny-stack">
														<div className="w-col w-col-tiny-tiny-stack">
															<input
																id="gender-radio"
																type="radio"
																checked={
																	state.triageRequest.userGender &&
																	state.triageRequest.userGender === "Male"
																}
																value="Male"
																onChange={(e) => {
																	state.triageRequest.userGender =
																		e.currentTarget.value;
																}}
																name="sex"
																pattern="[A-Za-z\s]{0,}[\S]{1,}[\s]{0,}"
																className="w-radio-input"
															/>
															<span className="w-radio w-radio-textsize">
																<Trans i18nKey="userregistration.radio-male">
																	Male
																</Trans>
															</span>
														</div>
														<div className="w-col w-col-tiny-tiny-stack">
															<input
																id="gender-radio-1"
																type="radio"
																value="Female"
																checked={
																	state.triageRequest.userGender &&
																	state.triageRequest.userGender === "Female"
																}
																onChange={(e) => {
																	state.triageRequest.userGender =
																		e.currentTarget.value;
																}}
																name="sex"
																pattern="[A-Za-z\s]{0,}[\S]{1,}[\s]{0,}"
																className="w-radio-input"
															/>
															<span className="w-radio w-radio-textsize">
																<Trans i18nKey="userregistration.radio-female">
																	Female
																</Trans>
															</span>
														</div>
													</div>
												</div>

												<div className="w-col w-col-tiny-tiny-stack">
													{this.state.mapLoaded && (
														<PlacesAutocomplete
															value={this.state.geoAddress}
															onChange={this.handleGeoChange}
															onSelect={(address, placeId) => {
																var request = {
																	placeId: placeId,
																};
																new Promise((resolve, reject) => {
																	new google.maps.places.PlacesService(
																		document.createElement("div")
																	).getDetails(request, (place, status) => {
																		if (
																			status ==
																			google.maps.places.PlacesServiceStatus.OK
																		) {
																			let postalCode = "";
																			let country = "";
																			let province = "";
																			let city = "";
																			let street = "";
																			let street_number = "";
																			for (
																				var placesIndex = 0;
																				placesIndex <
																				place.address_components.length;
																				placesIndex++
																			) {
																				for (
																					var streetNumberIndex = 0;
																					streetNumberIndex <
																					place.address_components[placesIndex]
																						.types.length;
																					streetNumberIndex++
																				) {
																					if (
																						place.address_components[
																							placesIndex
																						].types[streetNumberIndex] ===
																						"street_number"
																					) {
																						street_number =
																							place.address_components[
																								placesIndex
																							].long_name;
																					}
																				}
																				for (
																					var streetIndex = 0;
																					streetIndex <
																					place.address_components[placesIndex]
																						.types.length;
																					streetIndex++
																				) {
																					if (
																						place.address_components[
																							placesIndex
																						].types[streetIndex] === "route" ||
																						place.address_components[
																							placesIndex
																						].types[streetIndex] === "street"
																					) {
																						street =
																							place.address_components[
																								placesIndex
																							].long_name;
																					}
																				}
																				for (
																					var cityIndex = 0;
																					cityIndex <
																					place.address_components[placesIndex]
																						.types.length;
																					cityIndex++
																				) {
																					if (
																						place.address_components[
																							placesIndex
																						].types[cityIndex] ===
																							"administrative_area_level_2" ||
																						place.address_components[
																							placesIndex
																						].types[cityIndex] === "locality"
																					) {
																						city =
																							place.address_components[
																								placesIndex
																							].long_name;
																					}
																				}
																				for (
																					var provinceIndex = 0;
																					provinceIndex <
																					place.address_components[placesIndex]
																						.types.length;
																					provinceIndex++
																				) {
																					if (
																						place.address_components[
																							placesIndex
																						].types[provinceIndex] ===
																						"administrative_area_level_1"
																					) {
																						province =
																							place.address_components[
																								placesIndex
																							].long_name;
																					}
																				}
																				for (
																					var countryIndex = 0;
																					countryIndex <
																					place.address_components[placesIndex]
																						.types.length;
																					countryIndex++
																				) {
																					if (
																						place.address_components[
																							placesIndex
																						].types[countryIndex] === "country"
																					) {
																						country =
																							place.address_components[
																								placesIndex
																							].long_name;
																					}
																				}
																				for (
																					var postalIndex = 0;
																					postalIndex <
																					place.address_components[placesIndex]
																						.types.length;
																					postalIndex++
																				) {
																					if (
																						place.address_components[
																							placesIndex
																						].types[postalIndex] ===
																						"postal_code"
																					) {
																						postalCode =
																							place.address_components[
																								placesIndex
																							].long_name;
																					}
																				}
																			}
																			this.setState({
																				geoAddress: address,
																			});
																			state.triageRequest.street = street;
																			state.triageRequest.city = city;
																			state.triageRequest.country = country;
																			state.triageRequest.street_number =
																				street_number;
																			state.triageRequest.postalCode =
																				postalCode;
																			state.triageRequest.province = province;
																			resolve(place);
																		} else {
																			reject();
																		}
																	});
																});
															}}
															id="address-input"
															name="house"
															className={
																invalidFields.house
																	? "is-error"
																	: "text-field w-select"
															}
														>
															{({
																getInputProps,
																suggestions,
																getSuggestionItemProps,
																loading,
															}) => (
																<div>
																	<input
																		{...getInputProps({
																			placeholder: homecity,
																			className: dynamicClass,
																		})}
																	/>

																	<div className="autocomplete-dropdown-container">
																		{loading && <div>Loading...</div>}
																		{suggestions.map((suggestion) => {
																			const className = suggestion.active
																				? "suggestion-item--active"
																				: "suggestion-item";
																			const style = suggestion.active
																				? {
																						backgroundColor: "#fafafa",
																						cursor: "pointer",
																				  }
																				: {
																						backgroundColor: "#ffffff",
																						cursor: "pointer",
																				  };
																			return (
																				<div
																					{...getSuggestionItemProps(
																						suggestion,
																						{
																							className,
																							style,
																						}
																					)}
																				>
																					<span>{suggestion.description}</span>
																				</div>
																			);
																		})}
																	</div>
																</div>
															)}
														</PlacesAutocomplete>
													)}
													<div className="errormessage-address">
														{this.state.addressErrorMsg}
													</div>
												</div>
												<div className="column-2 w-col w-col-tiny-tiny-stack">
													<PhoneInput
														id="phone-input"
														specialLabel=""
														inputProps={{
															name: "phone",
															//className: dynamicClassPhone,
														}}
														autocomplete="off"
														autoFormat="true"
														enableSearch="true"
														localization={{
															de: "Deutschland",
															es: "España",
															fr: "Francais",
															en: "English",
														}}
														placeholder={i18next.t(
															"userregistration.user-phonenumber"
														)}
														containerClass=""
														value={
															state.triageRequest.profile &&
															state.triageRequest.profile.phone
																? state.triageRequest.profile.phone.trim()
																: fields.phone
														}
														inputClass="tel-input text-field w-input"
														className={
															invalidFields.phone
																? "is-error"
																: "text-field w-input"
														}
														isValid={(value, country) => {
															if (value.match(/12345/)) {
																return (
																	"Invalid value: " +
																	value +
																	", " +
																	country.name
																);
															} else if (value.match(/1234/)) {
																return false;
															} else {
																return true;
															}
														}}
														onChange={(phone) => this.setState({ phone })}
													/>
												</div>

												<div className="w-col w-col-tiny-tiny-stack">
													<p id="already">
														<Trans i18nKey="userregistration.Insurance">
															Insurance info:{" "}
														</Trans>
													</p>
												</div>
												<div className="w-col w-col-tiny-tiny-stack">
													<input
														id="insurance-input"
														type="text"
														name="Insurance"
														defaultValue={
															state.triageRequest.profile &&
															state.triageRequest.profile.Insurance
																? state.triageRequest.profile.Insurance.trim()
																: fields.Insurance
														}
														placeholder={i18next.t(
															"userregistration.insurancecarrier"
														)}
														pattern="[A-Za-z0-9\s.]{0,}[\S]{1,}[\s]{0,}"
														className={
															invalidFields.Insurance ? "is-error" : ""
														}
													/>
													<div className="errormessage-date">
														{this.state.insuranceErrorMsg}
													</div>
												</div>
												<div className="w-col w-col-tiny-tiny-stack">
													<input
														id="insurance-input"
														type="text"
														name="policy"
														defaultValue={
															state.triageRequest.profile &&
															state.triageRequest.profile.policy
																? state.triageRequest.profile.policy.trim()
																: fields.policy
														}
														placeholder={i18next.t("userregistration.Policy")}
														pattern="[A-Za-z0-9\s.]{0,}[\S]{1,}[\s]{0,}"
														className={invalidFields.policy ? "is-error" : ""}
													/>
													<div className="errormessage-date">
														{this.state.policyErrorMsg}
													</div>
												</div>
												<div className="column-2 w-col w-col-tiny-tiny-stack">
													<div className="w-col w-col-6 w-col-tiny-tiny-stack">
														<input
															id="date-effect"
															type="text"
															name="effectFrom"
															min={policyFromMinDate}
															defaultValue={
																state.triageRequest.profile &&
																state.triageRequest.profile.effectFrom
																	? state.triageRequest.profile.effectFrom.trim()
																	: fields.effectFrom
															}
															placeholder={i18next.t(
																"userregistration.date-effect"
															)}
															className={
																invalidFields.effectFrom
																	? "is-error"
																	: "text-field w-input"
															}
															onChange={(e) => {
																policyToMinDate = e.currentTarget.value;
																policyToMaxDate = getDate(
																	new Date(e.currentTarget.value),
																	1
																);
																setState({
																	enteredStartdate: e.currentTarget.value,
																});
																check(e);
															}}
															onFocus={(e) => {
																e.currentTarget.type = "date";
															}}
															onBlur={(e) => {
																e.currentTarget.placeholder =
																	"Effective From: (dd/mm/yyyy)";
															}}
														/>
														<div className="errormessage-date">
															{this.state.dateErrorMsgFrom}
														</div>
													</div>
													<div className="w-col w-col-6 w-col-tiny-tiny-stack">
														<input
															id="date-effectto"
															type="text"
															name="effectTo"
															min={policyToMinDate}
															max={policyToMaxDate}
															defaultValue={
																state.triageRequest.profile &&
																state.triageRequest.profile.effectTo
																	? state.triageRequest.profile.effectTo.trim()
																	: fields.effectTo
															}
															placeholder={i18next.t(
																"userregistration.date-effectto"
															)}
															className={
																invalidFields.effectTo
																	? "is-error"
																	: "text-field w-input"
															}
															onChange={(e) => {
																setState({
																	enteredEnddate: e.currentTarget.value,
																});
																check(e);
															}}
															onFocus={(e) => {
																e.currentTarget.type = "date";
															}}
															onBlur={(e) => {
																e.currentTarget.placeholder =
																	"Effective To: (dd/mm/yyyy)";
															}}
														/>
														<div className="errormessage-date">
															{this.state.dateErrorMsgTo}
														</div>
													</div>
												</div>
												<div>
													<div className="w-col w-col-tiny-tiny-stack">
														<div className="column-2 w-col w-col-9 w-col-tiny-tiny-stack insured text-bold">
															<Trans i18nKey="userregistration.toggle-msg">
																Are you the primary insured on the policy?
															</Trans>
														</div>
														<div className="column-2 w-col w-col-3 w-col-tiny-tiny-stack primary-policy">
															<Switch
																checked={this.state.checked}
																onChange={this.handleChange}
																onColor="#006fd6"
																onHandleColor="#2693e6"
																handleDiameter={30}
																checkedIcon={
																	<div className="Yes-toggle">
																		<Trans i18nKey="userregistration.toggle-yes">
																			Yes
																		</Trans>
																	</div>
																}
																uncheckedIcon={
																	<div className="No-Toggle">
																		<Trans i18nKey="userregistration.toggle-no">
																			No
																		</Trans>
																	</div>
																}
																className="react-switch"
																id="material-switch"
															/>
														</div>
													</div>
													<div>
														{this.state.checked ? (
															<div id="agree">
																<div>
																	<span>
																		<Trans i18nKey="userregistration.toggle-msg1">
																			By clicking Done, I agree that I have read
																			and accepted the{" "}
																		</Trans>
																		<span id="sign">
																			<Trans i18nKey="userregistration.toggle-msg2">
																				{" "}
																				Terms of Use.
																			</Trans>
																		</span>
																	</span>
																	<span>
																		<br />
																		<br />
																		<Trans i18nKey="userregistration.toggle-msg3">
																			See our
																		</Trans>
																		<span id="sign">
																			{" "}
																			<Trans i18nKey="userregistration.toggle-msg4">
																				Privacy Policy
																			</Trans>{" "}
																		</span>
																		<Trans i18nKey="userregistration.toggle-msg5">
																			for more details or to opt-out at any
																			time.
																		</Trans>
																	</span>
																</div>
																<div className="continue-btn">
																	<button className="button1 btn standby-button-gradient standby-button-gradient-blue btn-blue-rounded">
																		<Trans i18nKey="userregistration.done">
																			Done
																		</Trans>
																	</button>
																</div>
															</div>
														) : (
															<div id="agree">
																<div className="continue-btn">
																	<button
																		type="submit"
																		className="button1 btn standby-button-gradient standby-button-gradient-blue btn-blue-rounded"
																	>
																		<Trans i18nKey="userregistration.continue">
																			Continue{" "}
																		</Trans>
																	</button>
																</div>
															</div>
														)}
														{/* <div className="continue-btn">
															{" "}
															{!this.state.checked ? (
																<button type="submit" className="button1 btn standby-button-gradient standby-button-gradient-blue">
																<Trans i18nKey="userregistration.continue">Continue </Trans>
																</button>
															) : (
																<button className="button1 btn standby-button-gradient standby-button-gradient-blue">
																<Trans i18nKey="userregistration.done">Done</Trans></button>
															)}
														</div> */}
													</div>
												</div>
											</div>
										</div>
										<div className="w-col w-col-6 w-col-tiny-tiny-stack">
											<img src={terms} className="t-img" />
										</div>
									</div>
								) : (
									<UserCreatedSuccessfully
										{...{
											...this.props,
										}}
									/>
								)}
							</LoadingScreen>
						</div>
					)}
				</Form>
			</div>
		);
	}
}
export default Profile;
